import { useAtomValue, useSetAtom } from 'jotai';
import { portfoliosAtom } from '../atoms';

export const usePortfolios = () => useAtomValue(portfoliosAtom);

export const usePortfoliosUpdater = () => useSetAtom(portfoliosAtom);
